export const REBATE_REQUEST = "REBATE_REQUEST"
export const REBATE_SUCCESS = "REBATE_SUCCESS"
export const GET_STORE_REBATE_REQUEST = "GET_STORE_REBATE_REQUEST"
export const GET_STORE_REBATE_SUCCESS = "GET_STORE_REBATE_SUCCESS"